import React, { memo } from "react";

import { KTIcon } from "../../../../_metronic/helpers";
import { DocViewerSection } from "../../../../components/atoms/DocViewerSection";

const MultipleDocView = memo(({ closeModal, docURL, activeDoc }) => {
  return (
    <>
      <div
        id="ordlnk_modal_view_document"
        className="modal fade show d-block"
        aria-modal="true"
        role="dialog"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered mw-800px">
          <div className="modal-content">
            <div className="modal-header">
              <div></div>
              <div
                className="btn btn-icon btn-sm btn-active-icon-primary cursor-pointer"
                onClick={() => closeModal()}
              >
                <KTIcon className="fs-1" iconName="cross" />
              </div>
            </div>
            <div className="modal-body doc__modal scroll-y mx-5 my-5">
              <DocViewerSection
                documents={docURL}
                activeDoc={activeDoc}
                disableHeader={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
});

export { MultipleDocView };
